var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyrup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30859 9.5H10.4144M11.7864 9.5H15.8777",
    stroke: "#737373",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58398 6.37891H13.5985",
    stroke: "#737373",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58398 4.89062H13.5985",
    stroke: "#737373",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1169_54285",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H22V22H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1169_54285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6888 15.5421V14.4984H12.7203C12.9625 14.4984 13.1613 14.2973 13.1613 14.0511V13.4005C13.1613 13.1554 12.9625 12.9543 12.7203 12.9543H11.6888V11.9105C11.6888 11.6654 11.4902 11.4644 11.2479 11.4644H10.6049C10.3615 11.4644 10.1629 11.6654 10.1629 11.9105V12.9543H9.13137C8.8891 12.9543 8.69043 13.1554 8.69043 13.4005V14.0511C8.69043 14.2973 8.8891 14.4984 9.13137 14.4984H10.1629V15.5421C10.1629 15.7872 10.3615 15.9883 10.6049 15.9883H11.2479C11.4902 15.9883 11.6888 15.7872 11.6888 15.5421Z",
    stroke: "#737373",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4122 17.7273L4.60403 17.7296C3.60157 17.7296 3.47657 19.1969 4.77149 19.1969H12.4908C12.924 19.1969 13.3024 19.224 13.4419 19.8362C14.0838 22.6319 20.1699 22.4975 20.1699 18.0448C20.1699 17.8697 20.0282 17.7262 19.8552 17.7262L11.7752 17.7273",
    stroke: "#737373",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0293 11.5445C17.4914 12.2471 18.5944 13.7618 18.5944 14.6305C18.5944 15.7566 17.7426 16.3203 16.8909 16.3203C16.0391 16.3203 15.1885 15.7566 15.1885 14.6305C15.1885 13.7618 16.2903 12.2471 16.7525 11.5445C16.8618 11.3785 16.9199 11.3785 17.0293 11.5445Z",
    stroke: "#737373",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30697 19.1954V20.8412C6.30697 21.0615 6.48557 21.2422 6.70326 21.2422H10.4619H11.0915H11.7222H14.5387M15.876 12.897V9.26316C15.876 8.81699 15.9006 8.40019 15.5278 8.07375L13.5987 6.38277V2.64055C13.5987 2.44851 13.4436 2.29148 13.2538 2.29148H11.0915H8.93033C8.74053 2.29148 8.58424 2.44851 8.58424 2.64055V6.38277L6.65529 8.07375C6.28244 8.40019 6.30697 8.81699 6.30697 9.26316V17.7281M15.876 17.7259V16.0247",
    stroke: "#737373",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyrup);
export default __webpack_public_path__ + "static/media/syrup.bbde8235325476bf15949c04006a9c00.svg";
export { ForwardRef as ReactComponent };